import ReactECharts from 'echarts-for-react';

import { Industry } from '@/enums/Industry';
import { getIndustryResultAboutColors } from '@/utils/industryColors';

interface CircularProgressProps {
  score: number;
  sdgId: number;
  industry?: Industry;
}

export const getProgressOption = (score: number, industry?: Industry) => {
  const percentage = Math.round((score / 30) * 100);

  // Calculate font sizes based on viewport width for responsive scaling
  // Base: 25vw container → scale fonts proportionally
  const viewportWidth = window.innerWidth;
  const containerSize = viewportWidth * 0.25; // 25vw
  const mainFontSize = Math.round(containerSize * 0.4); // 40% of container
  const subFontSize = Math.round(containerSize * 0.08); // 8% of container
  const yOffset = Math.round(containerSize * 0.23); // 23% of container

  return {
    series: [
      {
        type: 'pie',
        radius: ['70%', '100%'],
        center: ['50%', '50%'],
        startAngle: 90,
        data: [
          {
            value: percentage,
            itemStyle: {
              color: getIndustryResultAboutColors(industry!).bgColor,
            },
            label: {
              show: false,
            },
          },
          {
            value: 100 - percentage,
            itemStyle: {
              color: '#cecece',
            },
            label: {
              show: false,
            },
          },
        ],
        silent: true,
        animation: false,
      },
    ],
    graphic: {
      type: 'group',
      left: 'center',
      top: '35%',
      children: [
        {
          type: 'text',
          x: -2,
          y: 0,
          style: {
            text: score.toString(),
            fontSize: mainFontSize,
            fontWeight: 100,
            fill: '#000000',
            textAlign: 'right',
            textBaseline: 'alphabetic',
          },
        },
        {
          type: 'text',
          x: 0,
          y: yOffset,
          style: {
            text: '/30',
            fontSize: subFontSize,
            fontWeight: 100,
            fill: '#000000',
            textAlign: 'left',
            textBaseline: 'alphabetic',
          },
        },
      ],
    },
    backgroundColor: 'transparent',
    animation: false,
  };
};

export const CircularProgress = ({
  score,
  industry,
}: CircularProgressProps) => {
  const progressOption = getProgressOption(score, industry);

  return (
    <ReactECharts
      option={progressOption}
      opts={{
        renderer: 'canvas',
        devicePixelRatio: 5,
      }}
      style={{ width: '25vw', height: '25vw' }}
    />
  );
};
